import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { activityService } from '@/services/activity.service';

const typeLabels: Record<string, string> = {
  webinar: 'וובינר',
  workshop: 'סדנה',
  training: 'הכשרה',
};

const typeColors: Record<string, string> = {
  webinar: 'bg-violet-50 text-violet-600 border-violet-200',
  workshop: 'bg-amber-50 text-amber-600 border-amber-200',
  training: 'bg-emerald-50 text-emerald-600 border-emerald-200',
};

export default function RecentActivity() {
  const [activities, setActivities] = useState<any[]>([]);

  useEffect(() => {
    activityService.list().then((all) => setActivities(all.slice(0, 4)));
  }, []);

  return (
    <div className="bg-white rounded-2xl border-2 border-rose-100 p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-gray-800 text-sm">פעילויות אחרונות</h3>
        <Link to="/admin/activities" className="text-xs text-rose-400 hover:text-rose-500 font-medium cursor-pointer">
          הצג הכל ←
        </Link>
      </div>
      <div className="space-y-3">
        {activities.map((act) => (
          <div key={act.id} className="flex items-center gap-3 p-3 rounded-xl bg-rose-50/50 border-2 border-rose-50 hover:border-rose-100 transition-all">
            <div className="w-10 h-10 flex items-center justify-center rounded-xl overflow-hidden flex-shrink-0">
              <img src={act.image || ''} alt={act.title} className="w-full h-full object-cover object-top" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold text-gray-700 truncate">{act.title}</p>
              <p className="text-xs text-gray-400">{act.date} · {act.location}</p>
            </div>
            <span className={`text-xs font-medium px-2 py-1 rounded-full border ${typeColors[act.type?.name || 'webinar']} whitespace-nowrap`}>
              {typeLabels[act.type?.name || 'webinar']}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
